module.exports = __webpack_public_path__ + "img/copy.c4515b80.svg";